var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('nuxt-img',{attrs:{"preset":_vm.preset,"src":_vm.src,"width":_vm.width,"height":_vm.height,"quality":_vm.quality,"sizes":_vm.sizes,"fit":_vm.fit,"format":"webp","loading":"lazy"},nativeOn:{"error":function($event){return _vm.setSrcWhenError($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }